angular.module('unergie.main')
.directive('barGraph', ($timeout, GraphGeneratorService, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/bargraph/bargraph.html',
        scope: {
            graphTitle: '=',
            data: '=',
            getData: '=',
            graphType: '=',
        },
        link: {
            post($scope) {
                $scope.refreshing = {}
                $scope.type = $scope.graphType || 'grouped'
                $scope.graphId = `graph${(Math.random() * 100000).toFixed(0)}`

                $scope.refreshData = function () {
                    $scope.refreshing[$scope.graphId] = true
                    return $scope.getData().then((result) => {
                        switch ($scope.type) {
                            case 'stacked':
                                GraphGeneratorService.createStackedGraph(`#${$scope.graphId}`, result)
                                break
                            case 'grouped':
                                GraphGeneratorService.createGroupedGraph(`#${$scope.graphId}`, result)
                                break
                            default:
                                GraphGeneratorService.createGroupedGraph(`#${$scope.graphId}`, result)
                        }
                        return $timeout(() => ($scope.refreshing[$scope.graphId] = false), 0)
                    })
                }

                $timeout($scope.refreshData, 0)

                $scope.changeType = function (type) {
                    $scope.type = type
                    return $scope.refreshData()
                }
            },
        },
    }),
)
